/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'react-dom',
	'@ba/ba-ui-carbon-toolkit',
	'jquery',
	'underscore',
	'../ExtensionBaseView'
], function(React, ReactDOM, toolkit, $, _, BaseView) {

	const { Grid, GridCell } = toolkit;

	class ForecastDetailsView extends BaseView {
		constructor(options){
			super(options);
		}

		render(container, resultTable){
			this.table = resultTable;
			this.containerNode = container;

			BaseView.clearContainer(this.containerNode);

			// class name is needed for using style from ba-ui-toolkit
			this.containerNode.classList.add('ba-theme-waca');
			return this._renderReactGrid();
		}

		_renderReactGrid() {
			return new Promise(resolve => {
				var props = {
					numColumns: this.table.getNumColumns(),
					numRows: this.table.getNumRows(),
					fixedRows: this.table.getNumHeaderRows(),
					fixedColumns: this.table.getNumFixedColumns(),
					autoMeasureColumnWidth: true,
					autoMeasureRowHeight: true,
					dataCellRenderer: this._cellRenderer.bind(this, this.table.getCell.bind(this.table)),
					fixedRowCellRenderer: this._cellRenderer.bind(this, this.table.getHeader.bind(this.table)),
					fixedColumnCellRenderer: this._cellRenderer.bind(this, this.table.getFixedColumn.bind(this.table))
				};
				ReactDOM.render(<Grid {...props} />, this.containerNode, () => resolve(props));
			});
		}

		_cellRenderer(getDataFn, rowIndex, colIndex, gridCellProps) {
			let data = getDataFn(rowIndex, colIndex);
			gridCellProps.style = _.extend({}, gridCellProps.style, data.style.gridCell || {});
			return this._getCellComponent(data.value, gridCellProps, data.style.cellValue.alignment );
		}

		_getCellComponent(value, gridCellProps, alignment){
			return (
				<GridCell {...gridCellProps}>
					<div style={BaseView.CELL.style[alignment || 'left']}>
						{value || ''}
					</div>
				</GridCell>
			);
		}

	}
	return ForecastDetailsView;
});
